interface StarterChipsProps {
  onPick: (text: string) => void;
  disabled?: boolean;
}

// Suggested first questions. Approved set (2026-06-25).
const STARTERS = [
  "What's included in each plan?",
  'Does it work with Walmart?',
  'How long does setup take?',
  'How do I reach support?',
];

export function StarterChips({ onPick, disabled }: StarterChipsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      {STARTERS.map((q) => (
        <button
          key={q}
          type="button"
          disabled={disabled}
          onClick={() => onPick(q)}
          className="rounded-full border border-brand-200 bg-white px-3.5 py-1.5 text-sm text-ink
                     transition-colors hover:border-brand-300 hover:bg-brand-50
                     disabled:cursor-not-allowed disabled:opacity-50"
        >
          {q}
        </button>
      ))}
    </div>
  );
}
